import { Box } from "@mui/material";

interface ThreeDShapesIconProps {
  size?: number;
}

/**
 * A little cluster of 3D primitives (cube, cone, cylinder) — used for the
 * standalone "3D Fuel" layer so it reads as 3D geometry rather than a fuel
 * scale.
 */
const ThreeDShapesIcon = ({ size = 24 }: ThreeDShapesIconProps) => (
  <Box
    sx={{
      width: size,
      height: size,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "inherit",
    }}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {/* Cube (top-left) */}
      <path d="M6 3 L10 5 L6 7 L2 5 Z" />
      <path d="M2 5 L2 9 L6 11 L6 7" />
      <path d="M10 5 L10 9 L6 11" />

      {/* Cone (top-right) */}
      <ellipse cx="18" cy="9" rx="4" ry="1.3" />
      <path d="M14 9 L18 3 L22 9" />

      {/* Cylinder (bottom) */}
      <ellipse cx="12" cy="15.4" rx="3.4" ry="1.2" />
      <path d="M8.6 15.4 L8.6 20.2" />
      <path d="M15.4 15.4 L15.4 20.2" />
      <path d="M8.6 20.2 A3.4 1.2 0 0 0 15.4 20.2" />
    </svg>
  </Box>
);

export default ThreeDShapesIcon;
